import React from 'react';

import './page404.css';

const Page404  = ({className, label, amount, onClick }) =>
    <div className="404_wrapper container">
        <h1 className="title">עמוד 404</h1>
    </div>;

export default Page404;
